import type { TableColumn } from "../../../../lib/interfaces";
import type { IServiceProfileTableDataRecord } from "./types";

const columnsWidths: Partial<Record<keyof IServiceProfileTableDataRecord, string>> = {
  id: "",
  name: "100px",
  profileTypeName: "150px",
  paymentTypeName: "150px",
  invoicePeriodName: "",
  prepaymentPeriodName: "150px",
  billPeriodName: "150px",
  prepaymentToPayDays: "150px",
  billToPayDays: "150px",
  period: "250px",
};

export const getServiceProfileColumns = (): TableColumn<IServiceProfileTableDataRecord>[] => [
  {
    title: "ID",
    key: "id",
    dataIndex: "id",
    width: columnsWidths.id,
    hidden: true,
  },
  {
    title: "Профиль",
    key: "name",
    dataIndex: "name",
    width: columnsWidths.name,
  },
  {
    title: "Тип профиля",
    key: "profileTypeName",
    dataIndex: "profileTypeName",
    width: columnsWidths.profileTypeName,
    hidden: true,
  },
  {
    title: "Тип оплаты",
    key: "paymentTypeName",
    dataIndex: "paymentTypeName",
    width: columnsWidths.paymentTypeName,
  },
  {
    title: "Расчетный период",
    key: "invoicePeriodName",
    dataIndex: "invoicePeriodName",
    width: columnsWidths.invoicePeriodName,
  },
  {
    title: "Период счета на предоплату",
    key: "prepaymentPeriodName",
    dataIndex: "prepaymentPeriodName",
    width: columnsWidths.prepaymentPeriodName,
  },
  {
    title: "Период счета на постоплату",
    key: "billPeriodName",
    dataIndex: "billPeriodName",
    width: columnsWidths.billPeriodName,
  },
  {
    title: "Срок на предоплату (дн)",
    key: "prepaymentToPayDays",
    dataIndex: "prepaymentToPayDays",
    width: columnsWidths.prepaymentToPayDays,
  },
  {
    title: "Срок на постоплату (дн)",
    key: "billToPayDays",
    dataIndex: "billToPayDays",
    width: columnsWidths.billToPayDays,
  },
  { title: "Период", key: "period", dataIndex: "period", width: columnsWidths.period },
];
